export const SUPPORT_CNFTS = true
